import { TreeSelect as AntdTreeSelect } from 'antd';
import type { TreeSelectProps } from 'antd';

export const TreeSelect: typeof AntdTreeSelect = Object.assign(
  (props: TreeSelectProps) => {
    const shouldEnableAutoClearSearchValue = props.multiple === true
      || (props.treeCheckable !== undefined && props.treeCheckable !== false);

    return (
      <AntdTreeSelect
        {...props}
        autoClearSearchValue={props.autoClearSearchValue ?? (shouldEnableAutoClearSearchValue ? true : undefined)}
      />
    );
  },
  AntdTreeSelect
) as typeof AntdTreeSelect;

export type { TreeSelectProps };
